import React from "react";
import noDataImg from "../../../assets/images/noData.svg";
import classes from "./styles.module.scss";

export default function NoDataFound({
  minHeight = "auto",
  minWidth = "auto",
  width = "auto",
  height = "auto",
  message,
}) {
  return (
    <div
      style={{ minHeight, minWidth, width: width, height }}
      className={classes.NoDataFound}
    >
      <img src={noDataImg} alt="No Data" />
      <p>{message || "No Results found."}</p>
    </div>
  );
}
